import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../constant/api";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import AuthBackground from "../../components/Home/AuthBackground/AuthBackground ";
import img from "../../assets/users/logo.png";  
/* ---------- helper ---------- */
const detectType = (value) => {
  if (/^\d{10}$/.test(value)) return "mobile";
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return "email";
  return "";
};
const ForgetPassword = () => {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    const from = location.state?.from || "/";

    // Form data for email, otp (for API calls) and new password.
    const [formData, setFormData] = useState({
        identifier: "",
        otp: "",
        type: "",
        reset_token: "",
        new_password: "",
    });
    // For multi-digit OTP UI, we use a separate state holding an array of 6 digits.
    const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));

    const [step, setStep] = useState(1);
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // New state for real-time new password validation error
    const [passwordError, setPasswordError] = useState("");

    // Create refs for each OTP input for easier focus management.
    const otpRefs = useRef([]);

    // Regex definitions for password validation.
    const minLengthRegex = /^.{8,}$/;
    const specialCharRegex = /[@#$%!^&*]/;
    const upperCaseRegex = /[A-Z]/;
    const digitRegex = /[0-9]/;

    // Compute the password criteria status based on the current new_password value.
    // const passwordCriteria = [
    //     { id: 1, label: "At least 8 characters", valid: minLengthRegex.test(formData.new_password) },
    //     { id: 2, label: "At least one special character (@#$%!^&*)", valid: specialCharRegex.test(formData.new_password) },
    //     { id: 3, label: "At least one uppercase letter", valid: upperCaseRegex.test(formData.new_password) },
    //     { id: 4, label: "At least one number", valid: digitRegex.test(formData.new_password) },
    // ];

    // Real-time new password validation effect.
    useEffect(() => {
        const password = formData.new_password;
        let err = "";
        if (password && !minLengthRegex.test(password)) {
            err = "Password must be at least 8 characters long.";
        } else if (password && !upperCaseRegex.test(password)) {
            err = "Password must contain at least one uppercase letter.";
        } 
        setPasswordError(err);
    }, [formData.new_password]);

    // Utility for input change (for email and new_password)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    // Utility for API calls.
    const apiCall = async (url, payload, successHandler, errorHandler) => {
        setIsLoading(true);
        setError("");
        try {
            const response = await axios.post(url, payload);
            // console.log(response.data);
            
            successHandler();
            return response.data;
        } catch (err) {
            errorHandler(err.response?.data?.message || "An error occurred.");
        } finally {
            setIsLoading(false);
        }
    };

    // --- OTP Input Handlers (Step 2) ---

    // When user types in one of the OTP boxes.
    const handleOtpChange = (index, value) => {
        // Only allow a single character per input.
        if (value.length > 1) {
            value = value.slice(-1);
        }
        const newOtpDigits = [...otpDigits];
        newOtpDigits[index] = value;
        setOtpDigits(newOtpDigits);
        // If there is a digit, automatically focus the next input.
        if (value && index < otpDigits.length - 1) {
            otpRefs.current[index + 1].focus();
        }
    };

    // Manage backspace behavior.
    const handleOtpKeyDown = (index, e) => {
        if (e.key === "Backspace" && otpDigits[index] === "" && index > 0) {
            otpRefs.current[index - 1].focus();
        }
    };

    // Handle paste event for the OTP inputs.
    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("text").trim();
        if (/^\d+$/.test(pasteData)) {
            const digits = pasteData.split("").slice(0, otpDigits.length);
            const newOtpDigits = Array(otpDigits.length)
                .fill("")
                .map((_, i) => digits[i] || "");
            setOtpDigits(newOtpDigits);
            // Optionally, focus the last input.
            if (digits.length >= otpDigits.length) {
                otpRefs.current[otpDigits.length - 1].focus();
            } else {
                otpRefs.current[digits.length].focus();
            }
        }
    };

    // --- Handlers for Each Step ---

    const handleRequestOtp = (e) => {
        e.preventDefault();
        if (!formData.identifier.trim()) {
            setError("Email or Mobile Number is required.");
            return;
        }
        apiCall(
            `${BASE_URL}/accounts/password-reset/request-otp/`,
            { identifier: formData.identifier, type: detectType(formData.identifier) },
            () => {
                setSuccessMessage("OTP sent to your email.");
                setStep(2);
            },
            setError
        );
    };
const handleVerifyOtp = (e) => {
  e.preventDefault();

  const otp = otpDigits.join("");
  if (otp.length < 6) {
    setError("Please enter the complete 6-digit OTP.");
    return;
  }

  apiCall(
    `${BASE_URL}/accounts/password-reset/verify-otp/`,
    {
      identifier: formData.identifier,
      type: detectType(formData.identifier),
      otp,
    },
    (response) => {
      setSuccessMessage(response.data.message); // ✅ "OTP verified"

      setFormData((prev) => ({
        ...prev,
        reset_token: response.data.reset_token, // ✅ TOKEN STORED
      }));

      setStep(3); // ✅ move to password reset screen
    },
    setError
  );
};

    

    const handleResetPassword = (e) => {
        e.preventDefault();
        if (!formData.new_password.trim()) {
            setError("New password is required.");
            return;
        }
        if (passwordError) {
            setError(passwordError);
            return;
        }
        apiCall(
            `${BASE_URL}/accounts/password-reset/reset/`,
            {
                reset_token: formData.reset_token,
                new_password: formData.new_password,
            },
            () => {
                setSuccessMessage("Password reset successful. Redirecting...");
                setTimeout(() => (window.location.href = "/login/email"), 0);
            },
            setError
        );
    };

    if (isAuthenticated) {
        return <Navigate to={from} />;
    }

    return (
        <div className="grid h-screen w-screen grid-cols-1 md:grid-cols-2">
            {/* Left Side */}
           <AuthBackground/>

            {/* Right Side */}
            <div className="flex flex-col items-center justify-center p-4 md:p-8">
                <div className="flex w-full sm:w-[450px] flex-col items-start border-0 md:border-2 border-solid px-5 md:p-10 rounded-xl">
                    <h1 className="text-3xl font-semibold ">Forgot Password?</h1>
                    <p className="text-sm text-gray-600">
                        {step === 1 && "Enter your email to request an OTP."}
                        {step === 2 && "Enter the OTP sent to your email."}
                        {step === 3 && "Enter your new password to reset it."}
                    </p>
                    <hr className="my-4" />

                    {/* Form */}
                    <form>
                        {step === 1 && (
                            <>
                                <input
                                    type="text"
                                    name="identifier"
                                    value={formData.identifier}
                                    onChange={handleChange}
                                    placeholder="Email or Mobile Number"
                                    className="border-brand-primary bg-gray-100 mb-4 w-full rounded-md border p-2"
                                    required
                                />
                                <button
                                    type="submit"
                                    onClick={handleRequestOtp}
                                    className="w-full rounded-xl px-6 font-semibold py-2 text-black transition duration-200 bg-[#FFAE00]"
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Requesting..." : "Request OTP"}
                                </button>
                            </>
                        )}

                        {step === 2 && (
                            <>
                                {/* OTP inputs with copy/paste support */}
                                <div className="flex justify-center" onPaste={handleOtpPaste}>
                                    {otpDigits.map((digit, index) => (
                                        <input
                                            key={index}
                                            type="text"
                                            inputMode="numeric"
                                            maxLength="1"
                                            value={digit}
                                            onChange={(e) =>
                                                handleOtpChange(index, e.target.value)
                                            }
                                            onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                            ref={(el) => (otpRefs.current[index] = el)}
                                            className="border-brand-primary bg-gray-100 mb-4  h-9 w-9 md:w-12 md:h-12 text-center rounded-md border p-2 mx-1 text-xl"
                                            required
                                        />
                                    ))}
                                </div>
                                <button
                                    type="submit"
                                    onClick={handleVerifyOtp}
                                    className="w-full rounded-xl px-6 font-semibold py-2 text-black transition duration-200 bg-[#FFAE00]"
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Verifying..." : "Verify OTP"}
                                </button>
                                <p className="text-center text-sm mt-4">
                                    Didn’t receive an OTP?{" "}
                                    <span
                                        className="cursor-pointer font-semibold text-[#FFAE00]"
                                        onClick={() => {
                                            // Allow the user to re-send the OTP by going back to the request step.
                                            setStep(1);
                                            setOtpDigits(Array(6).fill(""));
                                            setSuccessMessage(null);
                                            setError(null);
                                        }}
                                    >
                                        Resend OTP
                                    </span>
                                </p>
                            </>
                        )}

                        {step === 3 && (
                            <>
                                <div className="relative">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="new_password"
                                        value={formData.new_password}
                                        onChange={handleChange}
                                        placeholder="New Password"
                                        className="border-brand-primary bg-gray-100 mb-4 w-full rounded-md border p-2"
                                        required
                                    />
                                    <button
                                        type="button"
                                        className="absolute inset-y-0 right-0 bottom-4 flex items-center pr-2"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                                {passwordError && (
                                    <p className="text-red-500 text-sm mb-2">{passwordError}</p>
                                )}
                                {/* Display dynamic password criteria */}
                                {/* <ul className="mt-1 mb-4">
                                    <p className="text-xs font-semibold">Make your password strong by adding:</p>
                                    {passwordCriteria.map((criteria) => (
                                        <li
                                            key={criteria.id}
                                            className={`text-xs ${criteria.valid ? 'text-green-500' : 'text-red-500'}`}
                                        >
                                            {criteria.label}
                                        </li>
                                    ))}
                                </ul> */}
                                <button
                                    type="submit"
                                    onClick={handleResetPassword}
                                    className="w-full rounded-xl px-6 font-semibold py-2 text-black transition duration-200 bg-[#FFAE00]"
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Resetting..." : "Reset Password"}
                                </button>
                            </>
                        )}

                        {/* Error and Success Messages */}
                        {error && (
                            <p className="mt-4 text-sm text-red-500" aria-live="polite">
                                {error}
                            </p>
                        )}
                        {successMessage && (
                            <p className="mt-4 text-sm text-green-500" aria-live="polite">
                                {successMessage}
                            </p>
                        )}
                    </form>
                    {/* Footer Logo */}
                    <div className="my-10 flex justify-center items-center w-full">
                        <img src={img} alt="Bricks n Mix" className="h-12" />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ForgetPassword;
